import { Button, ButtonArea, DestructiveButton, Form, LoadingOverlay, Modal } from '@atrocit/scl';
import { gql, useMutation } from '@apollo/client';

export default function DeleteWageTableModal({ id, onClose }) {
	const [ deleteWageTable, deleteWageTableMutation ] = useMutation(gql`mutation Mutation($id: ID!) {
		deleteWageTable(id: $id)
	}`);

	return <Modal isOpen={true} title="Loontabel verwijderen" onRequestClose={onClose}>
		{deleteWageTableMutation.loading && <LoadingOverlay />}
		<Form onSubmit={() => deleteWageTable({ variables: { id } }).then(() => onClose())}>
			<div style={{ maxWidth: 'var(--u-512)' }}>
				Hiermee wordt deze loontabel verwijderd. Dit kan niet ongedaan gemaakt worden. Weet je het zeker?<br /><br />
			</div>

			<ButtonArea>
				<Button onClick={onClose}>Annuleren</Button>

				<DestructiveButton level="primary" type="submit">
					<span className="fa fa-trash" />&nbsp; Verwijderen
				</DestructiveButton>
			</ButtonArea>
		</Form>
	</Modal>;
}